import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i1110856773__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Rollstuhl", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i1110856773__cls-1{fill:none}.i1110856773__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M102.9 55.29H91.13c-3.89 0-7.39 2.15-9.13 5.6L73.78 77.2c12.22.06 23.46 4.36 32.36 11.52L106 58.34c0-1.69-1.4-3.06-3.1-3.06Z",
      class: "i1110856773__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("circle", {
      cx: "95.99",
      cy: "24.38",
      r: "8",
      class: "i1110856773__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M73.54 85.2C48.98 85.2 29 105.48 29 130.41s19.98 45.21 44.54 45.21 44.54-20.28 44.54-45.21S98.1 85.2 73.54 85.2",
      class: "i1110856773__cls-1"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("path", {
      d: "M111.99 24.38c0-8.82-7.18-16-16-16s-16 7.18-16 16 7.18 16 16 16 16-7.18 16-16m-24 0c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8M139.04 138.46l-6.61 4.51 16.64 24.38a4.01 4.01 0 0 0 3.31 1.75c.76 0 1.52-.21 2.2-.66l14.62-9.64a3.996 3.996 0 0 0 1.5-4.85l-19.01-46.44a4 4 0 0 0-3.68-2.48l-28.41-.18a53 53 0 0 0-5.42-8.11l-.18-38.4c-.02-6.08-5-11.03-11.1-11.03H91.13c-6.93 0-13.16 3.83-16.27 10L64.42 78.04c-24.63 4.39-43.41 26.2-43.41 52.39 0 29.34 23.57 53.21 52.54 53.21s52.54-23.87 52.54-53.21c0-6.15-1.05-12.05-2.95-17.55l22.17.14 16.75 40.92-8.59 5.67-14.42-21.13ZM81.99 60.89c1.74-3.46 5.24-5.6 9.13-5.6h11.77c1.71 0 3.1 1.37 3.1 3.06l.14 30.38c-8.91-7.16-20.15-11.47-32.36-11.52l8.22-16.31Zm-8.45 114.73c-24.56 0-44.54-20.28-44.54-45.21S48.98 85.2 73.54 85.2s44.54 20.28 44.54 45.21-19.98 45.21-44.54 45.21",
      class: "i1110856773__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "wheelchair"}) } }